import type {OptimalTimeResponse} from '@Components/email-marketing-campaign-performance/email-marketing-campaign-performance.types';

export const getReadableDateForOptimalSending = (utcTimestamp: number): string => {
  const utcDate = new Date(utcTimestamp * 1000);
  const localDate = new Date(utcDate.getTime());

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const readableDate = localDate.toLocaleDateString('en-US', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
  });

  const dayOfWeek = localDate.toLocaleString('en-US', {weekday: 'long'});

  const timeIn12HourFormat = localDate.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  if (localDate >= today && localDate < tomorrow) {
    return `${window.i18next.t('pmwjs_today')}, ${timeIn12HourFormat}`;
  }

  const dayAfterTomorrow = new Date(tomorrow);
  dayAfterTomorrow.setDate(tomorrow.getDate() + 1);

  if (localDate >= tomorrow && localDate < dayAfterTomorrow) {
    return `${window.i18next.t('pmwjs_tomorrow')}, ${timeIn12HourFormat}`;
  }

  return `${dayOfWeek}, ${readableDate}, ${timeIn12HourFormat}`;
};

export const getReadableTimeFromUtcTimestamp = (utcTimestamp: number): string => {
  const utcDate = new Date(utcTimestamp * 1000);
  const localDate = new Date(utcDate.getTime());
  return localDate.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const isCurrentTimeEqualToOrGreaterThanOptimalTimeComputed = (computedTime: number | null): boolean => {
  const now = new Date();
  now.setSeconds(0, 0);
  const currentTimeInUtc = Math.floor(now.getTime() / 1000);

  if (computedTime && currentTimeInUtc > computedTime) {
    return true;
  }

  return false;
};

export const isOptimalSendTimeforScheduledEmailsValid = (optimalTimeResponse: OptimalTimeResponse): boolean => {
  return !isCurrentTimeEqualToOrGreaterThanOptimalTimeComputed(optimalTimeResponse.minimumUtcTimestamp);
};
